/* eslint-disable import/no-unresolved */
import React from 'react';
import { isAdminRoleSelector, bleEnabledSelector } from '@store/common/selectors';
import { useSelector } from 'react-redux';

import FeatureCheck from '@components/common/FeatureCheck';
import ErrorLogicConfig from './ErrorLogicConfig';

const ErrorConfig = () => {
  const isAdmin = useSelector(isAdminRoleSelector);
  const bleEnabled = useSelector(bleEnabledSelector);

  const showErrorConfig = isAdmin && bleEnabled;

  return showErrorConfig ? <ErrorLogicConfig /> : <FeatureCheck featureName="Business Error Configuration" />;
};

export default ErrorConfig;
